// Mock data for LYNQnext Consulting Landing Page

export const carouselSlides = [
  {
    id: 1,
    title: "Digital Transformation for SMEs",
    subtitle: "Empowering businesses with strategic digital advisory and execution excellence",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80"
  },
  {
    id: 2,
    title: "MarTech Solutions That Scale",
    subtitle: "Navigate the complex martech landscape with expert guidance and implementation",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80"
  },
  {
    id: 3,
    title: "Partner Selection & Integration",
    subtitle: "Connect with the right technology partners to accelerate your digital journey",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80"
  },
  {
    id: 4,
    title: "Strategic Advisory for Growth",
    subtitle: "Tailored consulting solutions designed for India's dynamic SME ecosystem",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80"
  }
];

export const companyInfo = {
  name: "LYNQnext Consulting",
  tagline: "Connecting Vision with Execution",
  description: "LYNQnext Consulting is a specialized advisory firm dedicated to empowering Small & Medium Enterprises across India with cutting-edge digital and martech solutions. We bridge the gap between strategic vision and practical execution, offering comprehensive services in digital transformation, marketing technology implementation, and strategic partner selection.",
  lynqDescription: "LYNQ is our foundation. It's where we audit the chaos and find the signals that matter. It's a Proprietary Friction Diagnostic.",
  nextDescription: "NEXT is our promise. It's the predictive, profitable leap into the future. It's building the magnet – bringing the right elements.",
  closingStatement: "With a commitment to excellence and innovation, we help our clients navigate the complexities of digital adoption and emerge as leaders in their respective industries."
};

export const brandsEngagements = [
  {
    id: 1,
    name: "Neural Garage | SyncMonster",
    logo: "https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/p4nmjxfi_neural%20garage.jpeg",
    engagement: "From Patent to Pilot - transformed the deep-tech SaaS vision into a GTM sales engine"
  },
  {
    id: 2,
    name: "UniversityTech.io",
    logo: "https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/di8sny50_UT_WM_BLUEWHITE_SOCIAL.png",
    engagement: "Patent monetization platform - focus on academia & industry. Strategy for monetizing IPs & patents. Industry partner introductions."
  },
  {
    id: 3,
    name: "KlugKlug Technologies",
    logo: "https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/tnjtf42h_KlugLogo.png",
    engagement: "Business outreach plan. Sale of platform license to multiple agencies and brands."
  },
  {
    id: 4,
    name: "YelllowAndBlue",
    logo: "https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/dbb2mwlz_YnB%20Logo.jpg",
    engagement: "Growth advisory, image management & event participation."
  }
];

export const contactInfo = {
  address: "Goregaon East, Mumbai, India",
  phone: "+91-9821057386",
  email: "business@lynqnext.com"
};

export const submitEnquiry = async (formData) => {
  // Mock API call - simulates form submission
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Enquiry submitted:", formData);
      resolve({ success: true, message: "Thank you for your enquiry. We'll get back to you soon!" });
    }, 1000);
  });
};
